import 'regenerator-runtime/runtime';
import { vsosHttp as http } from 'lib/services/http';

const getPhoneNumbers = (
  { profileId = '' },
  ifIncludeLocationOutgoingNumber = true,
) => {
  return http.get('/phone-numbers', {
    params: {
      profileId,
      ifIncludeLocationOutgoingNumber,
    },
  });
};

const getRingPatterns = () => {
  return http.get('/phone-numbers/ring-patterns');
};

const removeAlternateNumber = (extension, phoneNumber, profileId: string) => {
  try {
    return http.delete(`/users/${profileId}/phone-numbers/alternate`, {
      params: {
        extension,
        phoneNumber,
      },
    });
  } catch (error: unknown) {
    return error;
  }
};

const getAvailablePhoneNumbers = () => {
  return http.get('/phone-numbers/available');
};

const getAvailableOutgoingPhoneNumbers = (locationId: string) => {
  return http.get(`/locations/${locationId}/phone-numbers/outgoing/available`);
};

const getPhoneNumbersForAccount = () => {
  return http.get('/account/phone-numbers');
};

export default {
  getPhoneNumbers,
  getRingPatterns,
  removeAlternateNumber,
  getAvailablePhoneNumbers,
  getAvailableOutgoingPhoneNumbers,
  getPhoneNumbersForAccount,
};
